import { render, staticRenderFns } from "./StorageLocationInShopRow.vue?vue&type=template&id=651f354d&scoped=true&"
import script from "./StorageLocationInShopRow.vue?vue&type=script&lang=js&"
export * from "./StorageLocationInShopRow.vue?vue&type=script&lang=js&"
import style0 from "./StorageLocationInShopRow.vue?vue&type=style&index=0&id=651f354d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f354d",
  null
  
)

export default component.exports